// Max amount limit for input fields 9_999_999_999 used on every number input field in the app
export const MAX_AMOUNT_LIMIT = 9999999999;
export const MIN_AMOUNT_LIMIT = 0;

export const MAX_YEARS_WORKED_LIMIT = 99;
export const MIN_YEARS_WORKED_LIMIT = 0;

export const MAX_TEST_SCORE = 999;

export const MAX_MONTHS_WORKED_LIMIT = 12;
export const MIN_MONTHS_WORKED_LIMIT = 0;

export const MAX_INTEREST_RATE_LIMIT = 100;
export const MIN_INTEREST_RATE_LIMIT = 1;
